export default "__VITE_ASSET__9c6dac1e__"